
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useIsMobile } from "@/hooks/use-mobile";

export function FeatureShowcase() {
  const isMobile = useIsMobile();
  
  const features = [
    {
      imageSrc: "/lovable-uploads/786bc681-3b49-4efa-9e0d-1c81bf8ca3b8.png",
      title: "Time Tracking",
    },
    {
      imageSrc: "/lovable-uploads/ce11ceb3-7e02-457d-b7f5-00aba710bac5.png",
      title: "Project Management",
    },
    {
      imageSrc: "/lovable-uploads/126458a5-a531-4d94-8fe3-ed8be78fe7a6.png",
      title: "Invoice Generation",
    },
    {
      imageSrc: "/lovable-uploads/087e1512-f500-4386-b0d3-e438b1a28848.png",
      title: "Analytics Dashboard",
    },
  ];

  return (
    <section className="py-10 bg-gradient-to-b from-muted/30 to-white">
      <div className="container">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
          <span className="bg-gradient-primary text-transparent bg-clip-text">
            Powerful Features at Your Fingertips
          </span>
        </h2>
        
        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="group hover-scale relative overflow-hidden rounded-xl border shadow-md bg-white"
            >
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <AspectRatio ratio={16/9}>
                <img 
                  src={feature.imageSrc} 
                  alt={feature.title} 
                  className="w-full h-full object-cover"
                />
              </AspectRatio>
              
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                <h3 className="text-white font-semibold text-lg">{feature.title}</h3>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Hour Tracker combines powerful features with intuitive design to streamline your workflow and maximize productivity.
          </p>
        </div>
      </div>
    </section>
  );
}
